import { render, staticRenderFns } from "./premierSlider.vue?vue&type=template&id=06924650&scoped=true"
import script from "./premierSlider.vue?vue&type=script&lang=js"
export * from "./premierSlider.vue?vue&type=script&lang=js"
import style0 from "./premierSlider.vue?vue&type=style&index=0&id=06924650&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06924650",
  null
  
)

export default component.exports